// @mui
import { Theme } from "@mui/material/styles";
// theme
import { ColorSchema } from "../palette";
//
import { ErrorIcon, SuccessIcon, WarningIcon } from "./CustomIcons";
import InfoIcon from "src/assets/icon/info";

// ----------------------------------------------------------------------

export default function Alert(theme: Theme) {
  const isLight = theme.palette.mode === "light";

  const standardStyle = (color: ColorSchema) => ({
    color: theme.palette[color][isLight ? "darker" : "lighter"],
    backgroundColor: theme.palette[color][isLight ? "lighter" : "darker"],
    "& .MuiAlert-icon": {
      color: theme.palette[color].dark,
    },
  });

  const filledStyle = (color: ColorSchema) => ({
    color: theme.palette[color].contrastText,
  });

  const outlinedStyle = (color: ColorSchema) => ({
    color:
      color === "info"
        ? theme.palette.primary.light
        : theme.palette[color].dark,
    border: `solid 1px ${theme.palette[color].dark}`,
    backgroundColor: theme.palette[color].light,
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: theme.typography.pxToRem(14),
    "& .MuiAlert-icon": {
      color: theme.palette[color].dark,
    },
  });

  return {
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          info: <InfoIcon customColor={theme.palette.info.dark} />,
          success: <SuccessIcon />,
          warning: <WarningIcon />,
          error: <ErrorIcon />,
        },
      },

      styleOverrides: {
        message: {
          padding: 0,
          "& .MuiAlertTitle-root": {
            marginBottom: theme.spacing(0.5),
            my: "auto",
          },
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        },
        action: {
          "& button:not(:first-of-type)": {
            marginLeft: theme.spacing(1),
          },
        },

        standardInfo: standardStyle("info"),
        standardSuccess: standardStyle("success"),
        standardWarning: standardStyle("warning"),
        standardError: standardStyle("error"),

        filledInfo: filledStyle("info"),
        filledSuccess: filledStyle("success"),
        filledWarning: filledStyle("warning"),
        filledError: filledStyle("error"),

        outlinedInfo: outlinedStyle("info"),
        outlinedSuccess: outlinedStyle("success"),
        outlinedWarning: outlinedStyle("warning"),
        outlinedError: outlinedStyle("error"),
      },
    },
  };
}
